import * as React from 'react';
import { useSelector } from 'react-redux';

import {
  selectActiveCategoriesFilter,
  selectActiveRoomsFilter,
  selectActiveStatusFilter,
  selectCategoriesFilters,
  selectRoomsFilters,
  selectStatusFilters,
} from '../../../selectors/offersHistory';
import { Filter, Filters } from '../components';
import { TypeFilterContainer } from './TypeFilterContainer';
import { useHandleCategoriesFiltersClick } from './utils/useHandleCategoriesFiltersClick';
import { useHandleRoomsFiltersClick } from './utils/useHandleRoomsFiltersClick';
import { useHandleStatusFiltersClick } from './utils/useHandleStatusFiltersClick';

/**
 * Контейнер собирает блок фильтров
 *   * фильтр расположения
 *   * фильтры статусов
 *   * фильтры комнат
 * Если по какому-то отдельному фильтру данных нет - он не будет отрендерен
 * */
export const FiltersContainer: React.FC = () => {
  const statusFilters = useSelector(selectStatusFilters);
  const roomsFilters = useSelector(selectRoomsFilters);
  const categoriesFilters = useSelector(selectCategoriesFilters);
  const statusFilterActiveValue = useSelector(selectActiveStatusFilter);
  const roomsFilterActiveValue = useSelector(selectActiveRoomsFilter);
  const categoriesFilterActiveValue = useSelector(selectActiveCategoriesFilter);
  const handleRoomsFiltersClick = useHandleRoomsFiltersClick();
  const handleStatusFiltersClick = useHandleStatusFiltersClick();
  const handleCategoriesFiltersClick = useHandleCategoriesFiltersClick();

  return (
    <Filters>
      <TypeFilterContainer />
      {statusFilters && (
        <Filter
          title="Статус объявления"
          spliced={false}
          options={statusFilters}
          value={statusFilterActiveValue}
          onChange={handleStatusFiltersClick}
        />
      )}
      {roomsFilters && (
        <Filter
          title="Количество комнат"
          spliced={false}
          options={roomsFilters}
          value={roomsFilterActiveValue}
          onChange={handleRoomsFiltersClick}
        />
      )}
      {categoriesFilters && (
        <Filter
          title="Тип объявления"
          spliced={false}
          options={categoriesFilters}
          value={categoriesFilterActiveValue}
          onChange={handleCategoriesFiltersClick}
        />
      )}
    </Filters>
  );
};
